import { render } from "./ico-language.vue?vue&type=template&id=69a4aca6&scoped=true"
const script = {}

import "./ico-language.vue?vue&type=style&index=0&id=69a4aca6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a4aca6"]])

export default __exports__